export const GET_DASHBOARD_QUEUE_TASKS = 'GET_DASHBOARD_QUEUE_TASKS';
export const GET_DASHBOARD_QUEUE_TASKS_SUCCESS = 'GET_DASHBOARD_QUEUE_TASKS_SUCCESS';
export const GET_DASHBOARD_QUEUE_TASKS_ERROR = 'GET_DASHBOARD_QUEUE_TASKS_ERROR';
